import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const TimeCalendarIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width={props.width ? props.width : "13.5"}
      height={props.height ? props.height : "15"}
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 13.5 15"
      {...props}
    >
      <g>
        <path id="Path_calendar-month" data-name="Path / calendar-month" d="M7.5,7.75v1.5H6V7.75H7.5m3,0v1.5H9V7.75h1.5m3,0v1.5H12V7.75h1.5M15,2.5A1.5,1.5,0,0,1,16.5,4V14.5A1.5,1.5,0,0,1,15,16H4.5A1.5,1.5,0,0,1,3,14.5V4A1.5,1.5,0,0,1,4.5,2.5h.75V1h1.5V2.5h6V1h1.5V2.5H15m0,12V6.25H4.5V14.5H15M7.5,10.75v1.5H6v-1.5H7.5m3,0v1.5H9v-1.5h1.5m3,0v1.5H12v-1.5Z" transform="translate(-3 -1)" />
      </g>
    </StyledSVGIcon>
  );
};